<template>
  <LabeledSelect
    class="documents-list__select"
    :label="label"
    :placeholder="placeholder"
    :required-icon="requiredIcon"
    :tooltip="tooltip"
    :is-disabled="isDisabled"
    :value="selectedDocumentId"
    :options="formattedDocuments"
    :select-first-by-default="selectFirstDocument"
    :empty-text="emptyStateText"
    value-key="id"
    label-key="displayLabel"
    @input="handleDocumentSelect"
  >
    <template #option="{ option }">
      <template v-if="option">
        <p class="documents-list-option__info-text">
          <strong>Документ:</strong> {{ option.document_name }}
        </p>
        <p class="documents-list-option__info-text">
          <strong>Серія та номер:</strong> {{ option.serial }} {{ option.number }}
        </p>
        <p v-if="option.issued_by" class="documents-list-option__info-text">
          <strong>Видано:</strong> {{ option.issued_by }}
        </p>
      </template>
    </template>
  </LabeledSelect>
</template>

<script>
import { LabeledSelect } from '@/shared/ui/form';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      default: 'Оберіть необхідний документ',
    },
    placeholder: {
      type: String,
      default: 'Оберіть документ',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    documentId: {
      type: [String, Number, null],
      default: null,
    },
    documentsList: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    selectFirstDocument: {
      type: Boolean,
      default: true,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      selectedDocumentId: null
    };
  },
  mounted() {
    this.initializeSelection();
  },
  components: { LabeledSelect },
  computed: {
    formattedDocuments() {
      return this.documentsList?.filter(doc => doc?.document_name && doc?.serial && doc?.number)?.map(doc => ({
        id: doc?.id,
        displayLabel: `${doc?.document_name} (${doc?.serial} ${doc?.number})`,
        document_id: doc?.document_id,
        document_name: doc?.document_name,
        serial: doc?.serial,
        number: doc?.number,
        document_type: doc?.document_type,
        issued_by: doc?.issued_by,
        date_of_issue: doc?.date_of_issue,
        end_date_of_issue: doc?.end_date_of_issue,
      }));
    },
  },
  methods: {
    initializeSelection() {
      if (this.documentId) {
        const documentExists = this.formattedDocuments?.find(doc => doc.id === this.documentId);
        if (documentExists) {
          this.handleDocumentSelect(this.documentId);
          return;
        }
      }

      if (this.documentsList?.length === 1 && this.selectFirstDocument) {
        this.handleDocumentSelect(this.documentsList[0]?.id);
      }
    },
    handleDocumentSelect(selectedId) {
      this.selectedDocumentId = selectedId;
      const idToCompare = typeof selectedId === 'object' ? selectedId?.id : selectedId;
      const selectedDocument = this.formattedDocuments.find(doc => doc.id === idToCompare);
      this.$emit('input', selectedDocument);
      this.$emit('change', selectedDocument);
    },
  },
  watch: {
    documentId: {
      handler(newDocumentId) {
        if (newDocumentId) {
          const documentExists = this.formattedDocuments?.find(doc => doc.id === newDocumentId);
          if (documentExists) {
            this.handleDocumentSelect(newDocumentId);
          }
        }
      },
      immediate: true,
    },
    documentsList: {
      handler() {
        this.initializeSelection();
      },
    }
  },
};
</script>

<style lang="scss" scoped>
.documents-list__select {
  width: 100%;
}

.documents-list-option__info-text {
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  strong {
    font-weight: 600;
  }
}
</style>
